import { Camera, CameraOff, AlertTriangle } from 'lucide-react';
import type { PhotoPolicy } from '@/shared/api/types';

const MAP: Record<PhotoPolicy, { label: string; cls: string; Icon: typeof Camera }> = {
  ALLOWED: { label: 'Fotos erlaubt', cls: 'bg-green-100 text-green-700', Icon: Camera },
  RESTRICTED: { label: 'Fotos nur nach Absprache', cls: 'bg-amber-100 text-amber-700', Icon: AlertTriangle },
  FORBIDDEN: { label: 'Keine Fotos', cls: 'bg-red-100 text-red-700', Icon: CameraOff },
};

export function PhotoPolicyBadge({ policy }: { policy: PhotoPolicy }) {
  const { label, cls, Icon } = MAP[policy];
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${cls}`}>
      <Icon className="h-3 w-3" />
      {label}
    </span>
  );
}
